var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-select',{attrs:{"hide-details":"auto","dark":"","outlined":"","value":_vm.selectedLocale,"items":_vm.availableLocales,"item-text":"name","item-value":"code","label":"Language"},on:{"change":_vm.localeChanged}})}
var staticRenderFns = []

export { render, staticRenderFns }